import React from 'react';
import { ArrowDownIcon, PlayIcon } from 'lucide-react';
import { Container, Section } from '../ui/Section';
import { Reveal } from '../motion/Reveal';
import { DoodleScatter } from '../brand/DoodleScatter';
import { videoPosterPhoto } from '../../data/photos';
type WelcomeVideoProps = {
  /** Once a real montage file exists, pass its hosted MP4/WebM URL here. */
  videoSrc?: string;
};
export function WelcomeVideo({
  videoSrc
}: WelcomeVideoProps) {
  return <Section className="relative overflow-hidden bg-[#fffdf6] py-16 sm:py-20" labelledBy="video-heading" data-id="element-205" data-mp="336luj1f5vxi1">
      <DoodleScatter tone="white" seed="welcome-video" data-id="element-206" data-mp="2u44bevuszkz9" />
      <Container className="relative max-w-4xl" data-id="element-207" data-mp="2u5nromgglw11">
        <Reveal data-id="element-208" data-mp="2y4wipjk47fsw">
          <h2 id="video-heading" className="font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-4xl" data-id="element-209" data-mp="2y6hflftwjatx">
            See what BCM is like
          </h2>
          <p className="mt-4 flex items-center gap-2 font-sans text-[17px] leading-relaxed text-ink" data-id="element-210" data-mp="wd1ko6qs79t5">
            See exactly what BCM is all about!
            <ArrowDownIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-brand-navy" data-id="element-211" data-mp="237gh0n73sejl" />
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-8 overflow-hidden rounded-[20px] border-2 border-brand-navy bg-brand-blue" data-id="element-212" data-mp="2d05nf3nsr282">
          {videoSrc ? <video controls preload="metadata" className="aspect-video w-full bg-black" aria-label="UCF BCM welcome video" data-id="element-213" data-mp="282vs57dq7wcb">
              <source src={videoSrc} data-id="element-214" data-mp="1fe89ljkd3l2g" />
              Your browser does not support embedded video.
            </video> : <div className="relative" data-id="element-215" data-mp="1p9ia22v43ke4">
              {videoPosterPhoto.src ? <img src={videoPosterPhoto.src} alt={videoPosterPhoto.alt} className="aspect-video w-full object-cover" data-id="element-216" data-mp="35o1he0lzeg15" /> : <div className="aspect-video w-full" data-id="element-217" data-mp="37swrij2hutte" />}
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-brand-navy/55" data-id="element-218" data-mp="37urahru7gbuu">
                <span aria-hidden="true" className="flex h-16 w-16 items-center justify-center rounded-full border-2 border-white/70 bg-white/25" data-id="element-219" data-mp="3hqucmxp24ahs">
                  <PlayIcon className="h-7 w-7 text-white" data-id="element-220" data-mp="2p25jply5nbh4" />
                </span>
                <p className="rounded-full bg-brand-tan px-4 py-2 font-meta text-[13px] font-semibold text-brand-navy" data-id="element-221" data-mp="2p02l4dixsa0s">
                  Video coming soon
                </p>
              </div>
            </div>}
        </Reveal>
      </Container>
    </Section>;
}